import { wait } from './wait';
export function waitFor(check, options) {
    const { checkInterval = 200, timeout } = options !== null && options !== void 0 ? options : {};
    const { afterReady, setReady, setFailed } = wait();
    const startTimestamp = Date.now();
    const doCheck = () => {
        try {
            const result = check();
            if (result) {
                setReady(result);
                return;
            }
            if (timeout && Date.now() - startTimestamp > timeout) {
                setFailed(new Error('timeout'));
                return;
            }
            setTimeout(doCheck, checkInterval);
        }
        catch (err) {
            setFailed(err);
        }
    };
    doCheck();
    return afterReady();
}
